import styled from 'styled-components';

import { SanityBlockRenderer } from 'components/sanity-block-renderer';

import { theme } from '../theme';

export const Row = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: ${props =>
    props.blockTextInversion ? theme.rowInversionBackgroundColor : theme.backgroundColor};
  color: ${props => (props.blockTextInversion ? theme.rowInversionTextColor : Styles.color.black)};
`;

export const AnchorWidget = styled.div`
  position: relative;
  inset-block-start: -110px;
  visibility: hidden;
`;

export const UnknownWidget = styled.div`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  background: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  flex-grow: 1;
  padding: 2rem;
  ${Styles.mobile} {
    padding: 1rem;
  }
`;

export const BlockWidgetContainer = styled(SanityBlockRenderer)`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 90%;
  max-width: 730px;
  flex-grow: 1;

  @media screen and (min-width: 769px) {
    h1 {
      font-size: 3.438rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    h2 {
      font-size: 2.188rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    h3 {
      font-size: 1.75rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    h4 {
      font-size: 1.15em;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    h5 {
      font-size: 1.15rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    p {
      font-size: 1.125rem;
      line-height: 1.66em;
    }
  }

  /* Mobile */
  @media screen and (max-width: 768px) {
    h1 {
      font-size: 2.188rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    h2 {
      font-size: 1.75rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    h3 {
      font-size: 1.15rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    h4 {
      font-size: 1.15rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    h5 {
      font-size: 1.125rem;
      font-weight: 300;
      padding-block-start: 2rem;
      padding-block-end: 0;
      padding-inline: 0;
      margin-block-start: 0;
      margin-block-end: 0.66rem;
      margin-inline: 0;
    }
    p {
      font-size: 1rem;
      line-height: 1.66em;
    }
  }

  & > p {
    margin: 0;
    & + p {
      margin-block-start: 1rem;
    }
    &:first-child {
      margin-block-start: 2rem;
    }
  }
  ol:last-child,
  ul:last-child,
  p:last-child {
    margin-block-end: 3rem;
  }
  * > a {
    text-decoration: none;
    color: ${Styles.color.primary};
  }
`;
